import React, { useState } from 'react'
import Form from 'react-bootstrap/Form';
import './App.css'
import { Button } from 'react-bootstrap';

import lpImage from './lp-hero-banner.jpg';


const Home = () => {
  const [emailInput, setEmailInput] = useState('');
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);

  const handleEmailInput = (e) => {
    setEmailInput(e.target.value);
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault();  
    setIsFormSubmitting(true);  

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const formData = {"fields": [{"name": "email", "value": emailInput}]}
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(formData),
      redirect: "follow",
    };

    await fetch(
      "https://api.hsforms.com/submissions/v3/integration/submit/21984071/43a5400c-e96c-4d14-9845-86ad7bc1b6e9",
      requestOptions
    ).then((response) => {
        if (response.ok) {
          console.log("Data successfully sent to HubSpot.");
          setIsFormSubmitted(true);
          return true;
        } else {
          console.error("Failed to send data to HubSpot.");
          return false;
        }
        
      }
    ).catch((error) => {
        console.error("Error sending data to HubSpot:", error);
        isFormSubmitting(false);
        return false;
      }
    );



    
  }

  return (
    <div className='flex p-2 lp-container'>
      <div className="flex lp-home">
        <div className="lp-home-left">
          <div className='lp-home-content'>
            <h1>Get Your Report Now</h1>
            <p>Fill the form to signUp for Google Ads report</p>
            <div className="lp-home-form">
              {isFormSubmitted?
                <p className='form-success'>ThankYou for Submitting the form. Check Your Email For next Steps</p>
                :
                <Form onSubmit={handleFormSubmit}>
                <p style={{fontSize:"14px",marginBottom:"5px",paddingLeft:"5px"}}>Enter the Google Ads email ID for which you want to generate the report.</p>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Control type="email" onChange={handleEmailInput} value={emailInput} placeholder="name@example.com" />
                </Form.Group>
                <Button disabled={isFormSubmitting?true:false} variant="primary" type="submit">
                  Submit
                </Button>
              </Form>
              }
              
            </div>
          </div>
        </div>
        <div className="lp-home-right">
          <img src={lpImage} alt="report" />
        </div>
      </div>
    </div>
  )
}

export default Home